'use client'

import { createImage } from '@gluestack-ui/core/image/creator'
import type { VariantProps } from '@gluestack-ui/utils/nativewind-utils'
import { tva } from '@gluestack-ui/utils/nativewind-utils'
import React from 'react'
import { type ImageSourcePropType, Platform, Image as RNImage } from 'react-native'

// Android OkHttp doesn't send Referer by default, causing CDN (qiniu) to return 404
const CDN_REFERER = 'https://jinshuju.net'
const CDN_HOST = 'jinshujufiles.com'

function withCDNHeaders(source: string | ImageSourcePropType | undefined): string | ImageSourcePropType | undefined {
  if (Platform.OS !== 'android' || !source || typeof source !== 'object' || Array.isArray(source)) return source
  const s = source as { uri?: string; headers?: Record<string, string> }
  if (s.uri?.includes(CDN_HOST) && !s.headers?.Referer) {
    return { ...s, headers: { ...s.headers, Referer: CDN_REFERER } }
  }
  return source
}

const imageStyle = tva({
  base: 'max-w-full',
  variants: {
    size: {
      '2xs': 'h-6 w-6',
      xs: 'h-10 w-10',
      sm: 'h-16 w-16',
      md: 'h-20 w-20',
      lg: 'h-24 w-24',
      xl: 'h-32 w-32',
      '2xl': 'h-64 w-64',
      full: 'h-full w-full',
      none: '',
    },
  },
})

const UIImage = createImage({ Root: RNImage })

type ImageProps = VariantProps<typeof imageStyle> & React.ComponentProps<typeof UIImage>
const Image = React.forwardRef<React.ComponentRef<typeof UIImage>, ImageProps & { className?: string }>(function Image(
  { size = 'md', className, source, ...props },
  ref
) {
  return (
    <UIImage
      className={imageStyle({ size, class: className })}
      source={withCDNHeaders(source)}
      {...props}
      ref={ref}
      // @ts-expect-error : web only
      style={Platform.OS === 'web' ? { height: 'revert-layer', width: 'revert-layer' } : undefined}
    />
  )
})

Image.displayName = 'Image'
export { Image }
